<!--
 * @Author: zhonghao
 * @Date: 2024-09-20 10:53:28
-->
<template>
  <div class="train-evaluate">
    <div class="comment-div" id="scroll">
      <div class="box">
        <!-- <div class="box_title">学习评价</div> -->
        <van-list
          id="list"
          v-model="commentState.loading"
          :finished="commentState && commentState.finished"
          :finished-text="commentState.finishText"
          :offset="10"
          @load="handleGetCommentList"
          class="comment-block"
        >
        <template v-if="commentListArr && commentListArr.length > 0">
          <div v-for="(item, index) in commentListArr" :key="index" class="comment-item" :class="item.own ? 'isown' : ''">
            <div class="header-div">
              <img :src="item && item.userInfo.headPicUrl" class="header-cover" alt="" />
              <div class="header-con">
                <div class="header-name">
                  <div class="header-name-txt">
                    {{ item && item.userInfo.nickName }}
                  </div>
                  <div class="own" v-if="item && item.own">我</div>
                  <div class="rate">
                    <van-rate
                      v-model="item.score"
                      allow-half
                      :size="14"
                      readonly
                      void-icon="star"
                      void-color="#eee"
                      color="#EB1700"
                    />
                    <span v-if="item.score >= 0">{{ item.score*2 }}分</span>
                  </div>
                </div>
                <div class="comment-con">
                  <div class="con-txt">{{ item && item.userInfo.hospitalName }}</div>
                </div>
              </div>
            </div>
            <div class="con">{{ item && item.content }}</div>
            <div class="con-date">{{ item && item.createTime }}</div>
          </div>
        </template>
        <div class="empty-block" v-else-if="isNone">
          <img
            src="@/assets/images/zone/img18.png"
            class="empty-img"
            alt=""
          />
          <div class="empty-txt">暂无内容</div>
        </div>
        </van-list>
      </div>
    </div>
    <div class="submit-btn" v-if="isFeedbackSign">
      <div class="btn-txt" @click="handleEva">我要评价</div>
    </div>
    <TrainModel ref="trainModel" :showCourseEvaluate.sync="showCourseEvaluate"/>
  </div>
</template>
<script>
import { getTrainingEvaluate, getIsEvaluate } from '@/api/training'
import TrainModel from './trainEvaluationModel.vue'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  components: { TrainModel },
  data() {
    return {
      commentState: {
        pageNo: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        finishText: '没有更多了'
      },
      commentListArr: [],
      isNone: false,
      showCourseEvaluate: false,
      isFeedbackSign: false,
      isJoin: false
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    campMainId() {
      return this.$route.query.campMainId
    },
    campId() {
      return this.$route.query.campId
    },
  },
  mounted() {
    getIsEvaluate({
      userId: this.userInfo.id,
      campId: this.campId
    }).then(res => {
      this.isFeedbackSign = (!res.data.isFeedback)
      this.isJoin = res.data.isJoin
    })
  },
  methods: {
    handleEva() {
      if (!this.isJoin) {
        this.$router.push({
          path: '/trainingList',
        })
        return
      }
      this.showCourseEvaluate = true
      this.$refs.trainModel.campId = this.campId
      this.$refs.trainModel.campMainId = this.campMainId
    },
    handleGetCommentList() {
      if (!this.campMainId) {
        this.commentState.loading = false
        this.commentState.finished = true
        this.commentState.finishText = ''
        this.isNone = true
        return
      }
      let params = {
        pageNum: this.commentState.pageNo,
        pageSize: this.commentState.pageSize,
        campMainId: this.campMainId,
        userId: this.userInfo.id
      }
      getTrainingEvaluate(params)
        .then(res => {
          this.$toast.clear()
          if (res) {
            if (res.code !== 0 || !res.data || !res.data.list) {
              this.commentState.loading = false
              this.commentState.finished = true
              this.commentState.finishText = ''
              return false
            }
            this.total = res.data.total
            res.data.list.map(item => {
              item.createTime = this.$moment(parseInt(item.createTime * 1)).format('YYYY-MM-DD HH:mm:ss')
              item.score = item.score / 2
            })
            if (res.data.list.length < this.commentState.pageSize) {
              this.commentState.finished = true
            }
            if (res.code === 0 && res.data.list) {
              this.commentListArr = this.commentListArr.concat(res.data.list)
            }
            this.commentState.pageNo++
            if (this.commentListArr.length === 0) {
              this.isNone = true
              this.commentState.finishText = ''
            }
          }
        })
        .catch(err => {
          this.$toast.clear()
          this.commentState.loading = false
          this.commentState.finished = true
          this.commentState.finishText = ''
          this.isNone = true
          console.log('err:', err)
        })
        .finally(() => {
          this.commentState.loading = false
        })
    },
  }
}
export default withRouteTracking(UserProfile)
</script>
<style scoped lang="less">
.train-evaluate {
  padding-bottom: 100px;
  box-sizing: border-box;
}
.submit-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  .btn-txt {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-size: 16px;
    color: #FFFFFF;
    font-weight: 500;
    text-align: center;
    background: #EB1700;
    width: 184px;
    height: 42px;
    text-align: center;
    line-height: 42px;
    border-radius: 100px;
  }
}
.comment-div {
  width: 100%;
  box-sizing: border-box;
  .loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -30%);
  }
}

.box_title {
  width: 100%;
  height: 46px;
  padding: 16px 0 0 11px;
  box-sizing: border-box;
  background-color: #fff;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 600;
  font-size: 16px;
  color: #000000;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.comment-block {
  width: 100%;
  background-color: #fff;
}
.comment-item {
  padding: 10px 14px;
  box-sizing: border-box;
}
.isown {
  background: linear-gradient( 90deg, #FDF3F3 0%, #FFFDFD 100%);
}
.header-div {
  display: flex;
  margin-bottom: 8px;

  .header-cover {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-right: 8px;
    object-fit: cover;
  }

  .header-con {
    .header-name {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 600;
      font-size: 14px;
      height: 20px;
      line-height: 20px;
      color: #000000;
      display: flex;
      align-items: center;
      .header-name-txt {
        width: 130px;
        display: block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    .own {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 10px;
      color: #fff;
      width: 18px;
      height: 18px;
      background-color: #EB1700;
      border-radius: 1px 100px 100px 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 2px;
    }

    .con-txt {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      color: #b1b1b1;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 280px;
    }
  }
}

.rate {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #7a8494;
  margin-left: 10px;
}
.con {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  margin-top: 8px;
  padding-left: 40px;
  box-sizing: border-box;
  line-height: 20px;
}
.con-date {
  line-height: 20px;
  font-size: 12px;
  color: #B1B1B1;
  padding-left: 40px;
  box-sizing: border-box;
  margin-top: 6px;
  font-family: PingFang HK, PingFang HK;
}
.empty-block {
  padding-top: 114px;
  box-sizing: border-box;
  .empty-img {
    width: 185px;
    display: block;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 10px;
  }
  .empty-txt {
    text-align: center;
    font-size: 14px;
    color: rgba(0,0,0,0.5);
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/training/trainEvaluate.vue